
import { ChatService } from "@/services/chat-service";
import { ChatState } from "@/utils/chat-state";
import Vue from "vue";
import { Thread } from "../../models/chat/thread";

export default Vue.extend({
	data() {
		return {
			thread: new Thread()
		};
	},
	props: {
		value: Boolean,
		state: {
			type: Object as () => ChatState,
			required: true
		},
	},
	watch: {
		value() {
			this.thread = new Thread();
		}
	},
	methods: {
		close() {
			this.$emit("input", false);
		},
		async save() {

			if (!this.state.openedConversation)
				return;

			let thread = await ChatService.createThread(this.thread, this.state.openedConversation);
			let message = this.thread.Title;

			await ChatService.postMessage(this.state.openedConversation.ID, message, null, thread.ThreadID);
			this.state.fetchThreads();
			this.close();
		}
	},
	i18nEx: {
		componentPrefix: "components.chat-NewThreadModal"
	}
});
